var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components__score-item-bubble"},[(_vm.scoreLevel)?_c('div',{class:_vm.bubbleCssClasses,style:({
      visibility:
        _vm.hiddenIfInactive && !_vm.active && _vm.scoreLevel.value !== _vm.currentValue
          ? 'hidden'
          : 'initial',
    }),attrs:{"title":_vm.tooltipPrefix + _vm.scoreLevel.tooltip},on:{"click":function($event){return _vm.$emit('trigger')}}},[_vm._v("\n    "+_vm._s(_vm.scoreLevel.label)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }